/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: bRXkugOm8Ra

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import StyleSelect from "../../components/style-controls/StyleSelect"; // plasmic-import: E0bKgamUEin/component
import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicSettingsTab.module.css"; // plasmic-import: bRXkugOm8Ra/css

import ArrowRightIcon from "../plasmic_kit/PlasmicIcon__ArrowRight"; // plasmic-import: etkVJMeZvaFjM/icon
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import PlusSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__PlusSvg"; // plasmic-import: sQKgd2GNr/icon

createPlasmicElementProxy;

export type PlasmicSettingsTab__VariantMembers = {};
export type PlasmicSettingsTab__VariantsArgs = {};
type VariantPropType = keyof PlasmicSettingsTab__VariantsArgs;
export const PlasmicSettingsTab__VariantProps = new Array<VariantPropType>();

export type PlasmicSettingsTab__ArgsType = {
  roles?: React.ReactNode;
  providerSettings?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSettingsTab__ArgsType;
export const PlasmicSettingsTab__ArgProps = new Array<ArgPropType>(
  "roles",
  "providerSettings"
);

export type PlasmicSettingsTab__OverridesType = {
  root?: Flex__<"div">;
  providerLabel?: Flex__<"div">;
  providerSelect?: Flex__<typeof StyleSelect>;
  directoryLabel?: Flex__<"div">;
  directorySelect?: Flex__<typeof StyleSelect>;
  manageBtn?: Flex__<typeof Button>;
  rolesLabel?: Flex__<"div">;
  addRoleBtn?: Flex__<typeof IconButton>;
  roleNeededRow?: Flex__<"div">;
  defaultRoleLabel?: Flex__<"div">;
  roleSelect?: Flex__<typeof StyleSelect>;
};

export interface DefaultSettingsTabProps {
  roles?: React.ReactNode;
  providerSettings?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicSettingsTab__RenderFunc(props: {
  variants: PlasmicSettingsTab__VariantsArgs;
  args: PlasmicSettingsTab__ArgsType;
  overrides: PlasmicSettingsTab__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.columns__kx3Gs)}>
        <div className={classNames("all", sty.column__udGuw)}>
          <div
            data-plasmic-name={"providerLabel"}
            data-plasmic-override={overrides.providerLabel}
            className={classNames("all", "__wab_text", sty.providerLabel)}
          >
            {"Provider"}
          </div>
        </div>
        <div className={classNames("all", sty.column__rW0DU)}>
          <StyleSelect
            data-plasmic-name={"providerSelect"}
            data-plasmic-override={overrides.providerSelect}
            className={classNames("__wab_instance", sty.providerSelect)}
            valueSetState={"isSet"}
          />
        </div>
      </div>
      <div className={classNames("all", sty.freeBox__it4Pf)}>
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.providerSettings,
        })}
      </div>
      <div className={classNames("all", sty.columns__dm2Yt)}>
        <div className={classNames("all", sty.column__oCxJ)}>
          <div
            data-plasmic-name={"directoryLabel"}
            data-plasmic-override={overrides.directoryLabel}
            className={classNames("all", "__wab_text", sty.directoryLabel)}
          >
            {"User directory"}
          </div>
        </div>
        <div className={classNames("all", sty.column__gHt5R)}>
          <div className={classNames("all", sty.freeBox__j41Mv)}>
            <StyleSelect
              data-plasmic-name={"directorySelect"}
              data-plasmic-override={overrides.directorySelect}
              className={classNames("__wab_instance", sty.directorySelect)}
              valueSetState={"isSet"}
            />

            <Button
              data-plasmic-name={"manageBtn"}
              data-plasmic-override={overrides.manageBtn}
              className={classNames("__wab_instance", sty.manageBtn)}
              endIcon={
                <ArrowRightIcon
                  className={classNames("all", sty.svg__o1Em8)}
                  role={"img"}
                />
              }
              size={"wide"}
              startIcon={
                <ArrowRightSvgIcon
                  className={classNames("all", sty.svg___4EIy)}
                  role={"img"}
                />
              }
              type={["clear"]}
              withIcons={["endIcon"]}
            >
              {"Manage"}
            </Button>
          </div>
        </div>
      </div>
      <div className={classNames("all", sty.columns__xu0Xg)}>
        <div className={classNames("all", sty.column__b3BAv)}>
          <div
            data-plasmic-name={"rolesLabel"}
            data-plasmic-override={overrides.rolesLabel}
            className={classNames("all", "__wab_text", sty.rolesLabel)}
          >
            {"Roles"}
          </div>
        </div>
        <div className={classNames("all", sty.column__bdpF)}>
          <div className={classNames("all", sty.freeBox__vp4T)}>
            {renderPlasmicSlot({
              defaultContents: null,
              value: args.roles,
            })}
          </div>
        </div>
        <div className={classNames("all", sty.column__m532O)}>
          <IconButton
            data-plasmic-name={"addRoleBtn"}
            data-plasmic-override={overrides.addRoleBtn}
            children2={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__qDk5)}
                role={"img"}
              />
            }
            className={classNames("__wab_instance", sty.addRoleBtn)}
          >
            <PlusSvgIcon
              className={classNames("all", sty.svg___3Ya4W)}
              role={"img"}
            />
          </IconButton>
        </div>
      </div>
      <div className={classNames("all", sty.freeBox__kvqUw)}>
        <div
          data-plasmic-name={"roleNeededRow"}
          data-plasmic-override={overrides.roleNeededRow}
          className={classNames("all", sty.roleNeededRow)}
        >
          <div className={classNames("all", sty.column__oO9R2)}>
            <div
              data-plasmic-name={"defaultRoleLabel"}
              data-plasmic-override={overrides.defaultRoleLabel}
              className={classNames("all", "__wab_text", sty.defaultRoleLabel)}
            >
              {"Default min role"}
            </div>
          </div>
          <div className={classNames("all", sty.column__f3Cki)}>
            <StyleSelect
              data-plasmic-name={"roleSelect"}
              data-plasmic-override={overrides.roleSelect}
              className={classNames("__wab_instance", sty.roleSelect)}
              valueSetState={"isSet"}
            />
          </div>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "providerLabel",
    "providerSelect",
    "directoryLabel",
    "directorySelect",
    "manageBtn",
    "rolesLabel",
    "addRoleBtn",
    "roleNeededRow",
    "defaultRoleLabel",
    "roleSelect",
  ],
  providerLabel: ["providerLabel"],
  providerSelect: ["providerSelect"],
  directoryLabel: ["directoryLabel"],
  directorySelect: ["directorySelect"],
  manageBtn: ["manageBtn"],
  rolesLabel: ["rolesLabel"],
  addRoleBtn: ["addRoleBtn"],
  roleNeededRow: ["roleNeededRow", "defaultRoleLabel", "roleSelect"],
  defaultRoleLabel: ["defaultRoleLabel"],
  roleSelect: ["roleSelect"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  providerLabel: "div";
  providerSelect: typeof StyleSelect;
  directoryLabel: "div";
  directorySelect: typeof StyleSelect;
  manageBtn: typeof Button;
  rolesLabel: "div";
  addRoleBtn: typeof IconButton;
  roleNeededRow: "div";
  defaultRoleLabel: "div";
  roleSelect: typeof StyleSelect;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSettingsTab__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSettingsTab__VariantsArgs;
    args?: PlasmicSettingsTab__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicSettingsTab__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSettingsTab__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSettingsTab__ArgProps,
          internalVariantPropNames: PlasmicSettingsTab__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicSettingsTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSettingsTab";
  } else {
    func.displayName = `PlasmicSettingsTab.${nodeName}`;
  }
  return func;
}

export const PlasmicSettingsTab = Object.assign(
  // Top-level PlasmicSettingsTab renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    providerLabel: makeNodeComponent("providerLabel"),
    providerSelect: makeNodeComponent("providerSelect"),
    directoryLabel: makeNodeComponent("directoryLabel"),
    directorySelect: makeNodeComponent("directorySelect"),
    manageBtn: makeNodeComponent("manageBtn"),
    rolesLabel: makeNodeComponent("rolesLabel"),
    addRoleBtn: makeNodeComponent("addRoleBtn"),
    roleNeededRow: makeNodeComponent("roleNeededRow"),
    defaultRoleLabel: makeNodeComponent("defaultRoleLabel"),
    roleSelect: makeNodeComponent("roleSelect"),

    // Metadata about props expected for PlasmicSettingsTab
    internalVariantProps: PlasmicSettingsTab__VariantProps,
    internalArgProps: PlasmicSettingsTab__ArgProps,
  }
);

export default PlasmicSettingsTab;
/* prettier-ignore-end */
